import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e32da46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial-dialog" }
const _hoisted_2 = { class: "tutorial-header" }
const _hoisted_3 = { class: "tutorial-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "step-dots",
  "aria-label": "Tutorial steps"
}
const _hoisted_9 = ["title", "onClick"]

import { computed, onMounted, ref } from "vue";
import DoubleLeftClickFocusIcon from "@/assets/Double_Left_Click_Focus.svg";
import HoldLeftClickRotateIcon from "@/assets/Hold_Left_Click_Rotate.svg";
import OneFingerRotationIcon from "@/assets/One_Finger_Rotation.svg";
import ScrollWheelPanIcon from "@/assets/Scroll_Wheel_Pan.svg";
import ScrollWheelZoomIcon from "@/assets/Scroll_Wheel_Zoom.svg";
import TwoFingerPanIcon from "@/assets/Two_Finger_Pan.svg";
import TwoFingerPinchZoomIcon from "@/assets/Two_Finger_Pinch_Zoom_In.svg";
import TwoFingerTapFocusIcon from "@/assets/Two_Finger_Tap_Focus.svg";

type TutorialDevice = "desktop" | "mobile";
type TutorialStep = { title: string; video: string; icon: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationTutorial',
  setup(__props, { expose }) {

const videoBasePath = "https://static.3dsurvey.si/cloud/";
const storageKeyPrefix = "navigation-tutorial-dismissed";

const stepSets: Record<TutorialDevice, TutorialStep[]> = {
	desktop: [
		step("Hold left click to rotate", "PC_Video_Hold_Left_Click_Rotate.webm", HoldLeftClickRotateIcon),
		step("Scroll wheel to zoom", "PC_Video_Scroll_Wheel_Zoom.webm", ScrollWheelZoomIcon),
		step("Scroll wheel click and hold to pan", "PC_Video_Scroll_Wheel_Pan.webm", ScrollWheelPanIcon),
		step("Double left click to focus", "PC_Video_Double_Click_Focus.webm", DoubleLeftClickFocusIcon),
	],
	mobile: [
		step("Drag to rotate", "Phone_Video_Drag_To_Rotate_1x1.webm", OneFingerRotationIcon),
		step("Pinch to zoom", "Phone_Video_Pinch_To_Zoom_1x1.webm", TwoFingerPinchZoomIcon),
		step("Two fingers to pan", "Phone_Video_Two_Fingers_To_Pan_1x1.webm", TwoFingerPanIcon),
		step("Double tap to focus", "Phone_Video_Double_Tap_Focus_1x1.webm", TwoFingerTapFocusIcon),
	],
};

const visible = ref(false);
const selectedIndex = ref<number | null>(null);
const device = ref<TutorialDevice>("desktop");

const steps = computed(() => stepSets[device.value]);
const currentStep = computed(() => steps.value[selectedIndex.value ?? 0]);

function step(title: string, file: string, icon: string): TutorialStep {
	return { title, icon, video: `${videoBasePath}${file}` };
}

function detectDevice(): TutorialDevice {
	return window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0 ? "mobile" : "desktop";
}

function show(force = false) {
	device.value = detectDevice();
	if (force || localStorage.getItem(`${storageKeyPrefix}-${device.value}`) !== "true") {
		selectedIndex.value = force ? null : 0;
		visible.value = true;
	}
}

function setStep(index: number) {
	selectedIndex.value = index;
}

function close() {
	localStorage.setItem(`${storageKeyPrefix}-${device.value}`, "true");
	visible.value = false;
}

onMounted(show);

expose({ show: () => show(true) });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (visible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tutorial-overlay",
          onClick: close
        }, [
          _createElementVNode("div", {
            class: "tutorial-stage",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            (selectedIndex.value && selectedIndex.value > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "arrow-button arrow-button-left",
                  type: "button",
                  title: "Previous",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (setStep(selectedIndex.value - 1)))
                }, "‹"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(selectedIndex.value === null ? "Navigation" : _unref(currentStep).title), 1),
                _createElementVNode("button", {
                  class: "icon-button",
                  type: "button",
                  title: "Close",
                  onClick: close
                }, "x")
              ]),
              (selectedIndex.value === null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(steps), (step, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: step.title,
                        class: "tutorial-menu-item",
                        type: "button",
                        onClick: ($event: any) => (setStep(index))
                      }, [
                        _createElementVNode("img", {
                          class: "tutorial-menu-icon",
                          src: step.icon,
                          alt: ""
                        }, null, 8, _hoisted_6),
                        _createElementVNode("span", null, _toDisplayString(step.title), 1)
                      ], 8, _hoisted_5))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["tutorial-video-frame", { mobile: device.value === 'mobile' }])
                    }, [
                      (_openBlock(), _createElementBlock("video", {
                        key: _unref(currentStep).video,
                        src: _unref(currentStep).video,
                        class: "tutorial-video",
                        autoplay: "",
                        muted: "",
                        playsinline: "",
                        "webkit-playsinline": "",
                        preload: "none",
                        loop: ""
                      }, null, 8, _hoisted_7))
                    ], 2),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(steps), (step, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: step.title,
                          type: "button",
                          title: step.title,
                          class: _normalizeClass({ active: index === selectedIndex.value }),
                          onClick: ($event: any) => (setStep(index))
                        }, null, 10, _hoisted_9))
                      }), 128))
                    ])
                  ], 64))
            ]),
            (selectedIndex.value !== null && selectedIndex.value < _unref(steps).length - 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "arrow-button arrow-button-right",
                  type: "button",
                  title: "Next",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setStep(selectedIndex.value + 1)))
                }, "›"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})